import { render, staticRenderFns } from "./StoreManagement.vue?vue&type=template&id=32cb089e&scoped=true&"
import script from "./StoreManagement.vue?vue&type=script&lang=js&"
export * from "./StoreManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb089e",
  null
  
)

export default component.exports